<!-- Logged In State -->
@if (isLoggedIn) {
<div class="m-t-1-s">
    <p class="h2">{{'You\'re logged in' | translate}}</p>
    <p class="m-t-1 m-t-3-s m-t-3-m p1">{{'Confirm your email to continue' | translate}}</p>

    <!-- Email display -->
    <input-wrap class="block fake-disabled">
        <input class="input"
               type="email"
               name="email"
               disabled
               [attr.placeholder]="'Email address' | translate"
               [muiInput]="'Email address' | translate"
               [value]="email">
    </input-wrap>

    <!-- Logout option -->
    <div class="m-t-2 p1">
        {{ 'Not you?' | translate }}
        <action class="button-inline no-fs"
                [style.margin]="'0 0.2em'"
                [status]="logoutStatus"
                (click)="logout()">
            {{'Click here' | translate}}
        </action>
        {{'to sign out.' | translate}}
        <span class="fs-3">{{'Items in your shopping bag will be kept.' | translate}}</span>
    </div>

    <!-- Continue button -->
    <button class="w-12 button m-t-2 m-t-4-m m-t-4-s"
            [action]="checkStatus"
            (click)="continue()">{{'Continue' | translate}}</button>
</div>
} @else {
<!-- Not Logged In State -->
<ng-form #form="ngForm"
         class="_blocks">
    <!-- Initial State - Block Selection -->
    @if (isInitialState()) {
    @for (block of orderedBlocks; track block.type) {
    @if (block.type === 'separator') {
    <div class="w-12 bg-col-4 _separator"></div>
    } @else {
    <ng-container *ngTemplateOutlet="blockTpl, context: {$implicit: block}" />
    }
    }
    }

    <!-- Guest Form State -->
    @for (block of orderedBlocks; track block.type) {
    @if (isGuestFormVisible() && block.type === 'guest_checkout') {
    <!-- @defer is needed here, it solves the issue of email input field being registered before previously registered one is destroyed-->
    @defer {
    <div class="w-12 b-radius-4 bg-col-5 _block"
         [attr.data-block-type]="'guest_checkout'">
        <div class="flex-column gap-4px">
            <h2 class="h2-bold"
                *iCms="'selectedTitle' of block; skipEmpty: true"></h2>
            <div class="p2"
                 *iCms="'selectedCopy' of block; content: 'html'; skipEmpty: true"></div>
        </div>

        <!-- Email -->
        <input-wrap class="block async-validation"
                    [class.has-validation]="canShowEmailValidate(emailInput?.value)"
                    [canShowValidate]="canShowEmailValidate(emailInput?.value)"
                    [messages]="{
                email: ('Valid email is required' | translate),
                required: ('Valid email is required' | translate),
                LOQATE_INVALID_EMAIL: ('Valid email is required' | translate)
            }">
            <input class="input"
                   type="email"
                   name="email"
                   data-cs-mask
                   required
                   [attr.placeholder]="'Email address' | translate"
                   validatePatternAsync="email"
                   [loqateEmail]="true"
                   [loqateEmailDebounceTime]="500"
                   [muiInput]="'Email address' | translate"
                   [muiInputValidateOnSubmit]="true"
                   [(ngModel)]="email"
                   [ngModelOptions]="{updateOn: 'blur'}"
                   (blur)="handleEmailBlur()"
                   (keydown)="handleKeyDown($event)"
                   #emailInput>
            @if (checkStatus.busy || !!form?.pending) {
            <span class="pos-absolute top-3 right-3 bottom-0 flex flex-middle flex-justify-center pe-none">
                <i class="icon-loading"
                   aria-hidden="true"></i>
            </span>
            }
        </input-wrap>

        <!-- First Name -->
        <input-wrap class="block async-validation"
                    [class.has-validation]="!!form?.submitAttempt"
                    [canShowValidate]="!!form?.submitAttempt">
            <input class="input"
                   type="text"
                   name="firstname"
                   maxlength="50"
                   data-cs-mask
                   required
                   [muiInput]="'First name' | translate"
                   [(ngModel)]="shippingAddressData.firstname">
        </input-wrap>

        <!-- Last Name -->
        <input-wrap class="block async-validation"
                    [class.has-validation]="!!form?.submitAttempt"
                    [canShowValidate]="!!form?.submitAttempt">
            <input class="input"
                   type="text"
                   name="lastname"
                   maxlength="50"
                   data-cs-mask
                   required
                   [muiInput]="'Surname' | translate"
                   [(ngModel)]="shippingAddressData.lastname">
        </input-wrap>

        <!-- Newsletter Opt-in -->
        @if (showSubscriptionOptIn) {
        <checkout-newsletter class="w-12 m-t-2"
                             [data]="data"
                             [source]="'checkout_guest_form'"
                             (dataChange)="dataChangeHandle($event)" />
        }

        <!-- Submit Button -->
        <button class="w-12 m-t-3"
                [class]="block.selectedCtaStyle || 'button'"
                [action]="checkStatus"
                [class.is-busy]="checkStatus.busy || !!form?.pending"
                (click)="continueAsGuestToDelivery()">
            <span *iCms="'selectedCtaText' of block"></span>
        </button>
    </div>

    <!-- Other Options (Sign In and Create Account remain visible) -->
    @if (isBlockEnabled('sign_in')) {
    @for (block of orderedBlocks; track block.type) {
    @if (block.type === 'sign_in') {
    <ng-container *ngTemplateOutlet="blockTpl, context: { $implicit: block, single: true }" />
    }
    }
    }
    }
    }

    <!-- Login Form State -->
    @if (isLoginFormVisible() && block.type === 'sign_in') {
    <!-- @defer is needed here, it solves the issue of email input field being registered before previously registered one is destroyed-->
    @defer {
    <div class="w-12 b-radius-4 bg-col-5 _block"
         [attr.data-block-type]="'sign_in'">
        <div class="flex-column gap-4px">
            <h2 class="h2-bold"
                *iCms="'selectedTitle' of block; skipEmpty: true"></h2>
            <div class="p2"
                 *iCms="'selectedCopy' of block; content: 'html'; skipEmpty: true"></div>
        </div>

        <!-- Email -->
        <input-wrap class="block async-validation"
                    [class.has-validation]="canShowEmailValidate(emailInput?.value)"
                    [canShowValidate]="canShowEmailValidate(emailInput?.value)"
                    [messages]="{
                    email: ('Valid email is required' | translate),
                    required: ('Valid email is required' | translate),
                    LOQATE_INVALID_EMAIL: ('Valid email is required' | translate)
                }">
            <input class="input"
                   type="email"
                   name="email"
                   required
                   email
                   [attr.placeholder]="'Email address' | translate"
                   [muiInput]="'Email address' | translate"
                   [muiInputValidateOnSubmit]="true"
                   validatePatternAsync="email"
                   [loqateEmail]="false"
                   [loqateEmailDebounceTime]="500"
                   [(ngModel)]="email"
                   [ngModelOptions]="{updateOn: 'blur'}"
                   (blur)="handleEmailBlur()"
                   (keydown)="handleKeyDown($event)"
                   #emailInput>
            @if (checkStatus.busy || !!form?.pending) {
            <span class="pos-absolute top-3 right-3 bottom-0 flex flex-middle flex-justify-center pe-none">
                <i class="icon-loading"
                   aria-hidden="true"></i>
            </span>
            }
        </input-wrap>

        <!-- Password -->
        <ng-container *ngTemplateOutlet="passwordTpl" />

        <!-- Newsletter Opt-in -->
        @if (showSubscriptionOptIn) {
        <checkout-newsletter class="w-12 m-t-2"
                             [data]="data"
                             [source]="'checkout_sign_in'"
                             (dataChange)="dataChangeHandle($event)" />
        }

        <!-- Submit Button -->
        <button class="w-12 m-t-3"
                [class]="block.selectedCtaStyle || 'button'"
                [action]="loginStatus"
                (click)="login(onLoginSuccess)">
            <span *iCms="'selectedCtaText' of block"></span>
        </button>

        <!-- Forgot Password -->
        <button class="w-12 button-1 cursor-pointer block m-t-2"
                [action]="passwordStatus"
                (click)="resetPassword()">
            {{'Forgotten password?' | translate}}
        </button>

        <result customClasses="block m-t-1 col-21 s1"
                [status]="passwordStatus"
                [success]="'If you have an account you\'ll receive an email to reset your password' | translate" />

        <result customClasses="block m-t-1 col-2 p1"
                [status]="loginStatus" />
    </div>

    <!-- Guest Checkout Option (moved below form) -->
    @if (isBlockEnabled('guest_checkout')) {
    @for (block of orderedBlocks; track block.type) {
    @if (block.type === 'guest_checkout') {
    <ng-container *ngTemplateOutlet="blockTpl, context: { $implicit: block, single: true }" />
    }
    }
    }
    }
    }

    <!-- Create Account Form State -->
    @if (isCreateAccountFormVisible() && block.type === 'create_account') {
    <div class="w-12 b-radius-4 bg-col-5 _block"
         [attr.data-block-type]="'create_account'">
        <div class="flex-column gap-4px">
            <h2 class="h2-bold"
                *iCms="'selectedTitle' of block; skipEmpty: true">
                {{'Create your account' | translate}}
            </h2>
            <div class="p2"
                 *iCms="'selectedCopy' of block; content: 'html'; skipEmpty: true">
                {{'Fill in your details to create an account​' | translate}}
            </div>
        </div>

        <!-- Email -->
        <input-wrap class="block async-validation"
                    [class.has-validation]="canShowEmailValidate(emailInput?.value)"
                    [canShowValidate]="canShowEmailValidate(emailInput?.value)"
                    [messages]="{
          email: ('Valid email is required' | translate),
          required: ('Valid email is required' | translate),
          LOQATE_INVALID_EMAIL: ('Valid email is required' | translate)
      }">
            <input class="input"
                   type="email"
                   name="email"
                   data-cs-mask
                   required
                   [attr.placeholder]="'Email address' | translate"
                   validatePatternAsync="email"
                   [loqateEmail]="true"
                   [loqateEmailDebounceTime]="500"
                   [muiInput]="'Email address' | translate"
                   [muiInputValidateOnSubmit]="true"
                   [(ngModel)]="email"
                   [ngModelOptions]="{updateOn: 'blur'}"
                   (blur)="handleEmailBlur()"
                   (keydown)="handleKeyDown($event)"
                   #emailInput>
        </input-wrap>

        @let firstNameValueLength = firstNameRef?.value?.length || 0;

        <!-- First Name -->
        <input-wrap class="block async-validation"
                    [class.has-validation]="firstNameValueLength > 1 || form.submitAttempt"
                    [canShowValidate]="firstNameValueLength > 1 || form.submitAttempt">
            <input class="input"
                   type="text"
                   name="firstname"
                   [muiInput]="'First name' | translate"
                   maxlength="50"
                   data-cs-mask
                   required
                   [(ngModel)]="shippingAddressData.firstname"
                   #firstNameRef>
        </input-wrap>

        @let lastNameValueLength = lastNameRef?.value?.length || 0;

        <!-- Last Name -->
        <input-wrap class="block async-validation"
                    [class.has-validation]="lastNameValueLength > 1 || form.submitAttempt"
                    [canShowValidate]="lastNameValueLength > 1 || form.submitAttempt">
            <input class="input"
                   type="text"
                   name="lastname"
                   [muiInput]="'Surname' | translate"
                   maxlength="50"
                   data-cs-mask
                   required
                   [(ngModel)]="shippingAddressData.lastname"
                   #lastNameRef>
        </input-wrap>

        <!-- Password -->
        <input-wrap class="block">
            <view-password>
                <input class="input"
                       type="password"
                       name="password"
                       required
                       minlength="6"
                       [attr.placeholder]="'Password' | translate"
                       [muiInput]="'Password' | translate"
                       [(ngModel)]="data.password">
            </view-password>
        </input-wrap>

        <!-- Terms & Conditions -->
        @if (content().termsAndConditions) {
        <input-wrap class="block m-t-2 p-a-2 bg-col-w"
                    [required]="true">
            <checkbox name="termsAndConditionChecked"
                      [required]="true"
                      [(ngModel)]="termsAndConditionChecked"
                      (ngModelChange)="detectChanges()">
                <span class="p2"
                      *iCms="'termsAndConditions' of content(); content: 'html'"></span>
            </checkbox>
        </input-wrap>
        }

        <!-- Newsletter Opt-in -->
        @if (showSubscriptionOptIn) {
        <checkout-newsletter class="w-12 m-t-2"
                             [data]="data"
                             [source]="'checkout_create_account'"
                             (dataChange)="dataChangeHandle($event)" />
        }

        <!-- Submit Button -->
        <button class="w-12 m-t-3"
                [class]="block.selectedCtaStyle || 'button'"
                [action]="registerStatus"
                cy-loginSignUp
                (click)="submitCreateAccountForm()">
            <span *iCms="'selectedCtaText' of block"></span>
        </button>
        @if (showAccountExistsError()) {
        <p class="block m-t-1 col-2 p1">{{'Account may already exist. Try signing in' | translate}}</p>
        } @else {
        <result customClasses="block m-t-1 p1"
                [status]="registerStatus" />
        }
    </div>

    @if (showAccountExistsError() && isBlockEnabled('sign_in')) {
    <ng-container *ngTemplateOutlet="blockTpl, context: { $implicit: getBlock('sign_in'), single: true }" />
    } @else if (isBlockEnabled('guest_checkout')) {
    <ng-container *ngTemplateOutlet="blockTpl, context: { $implicit: getBlock('guest_checkout'), single: true }" />
    }
    }
    }

    <ng-template #blockTpl
                 let-block
                 let-single="single">
        <div class="w-12 b-radius-4 _block"
             [class]="block.backgroundColor || 'bg-col-51'"
             [attr.data-block-type]="block.type">

            <div class="flex-column gap-4px _content">
                <h2 class="h2-bold"
                    *iCms="'title' of block; skipEmpty: true">{{block.title}}</h2>
                <div class="p2"
                     *iCms="'copy' of block; content: 'html'; skipEmpty: true">{{block.copy}}</div>
            </div>

            <button class="w-12"
                    [class]="single ? 'button-1' : block.ctaStyle || 'button'"
                    type="button"
                    (click)="onBlockClick(block)">
                <span *iCms="'ctaText' of block"></span>
            </button>
        </div>
    </ng-template>

    <ng-template #passwordTpl>
        <input-wrap class="block">
            <view-password>
                <input class="input"
                       type="password"
                       name="password"
                       data-cs-mask
                       [attr.placeholder]="'Enter password'"
                       required
                       [muiInput]="'Password' | translate"
                       [(ngModel)]="data.password"
                       (keyup.enter)="login(onLoginSuccess)">
            </view-password>
        </input-wrap>
    </ng-template>
</ng-form>
}

<!-- Form validation dummy field -->
<ng-form #stepForm="ngForm">
    @if (!isValid) {
    <input type="hidden"
           name="dummy"
           required
           [(ngModel)]="dummy">
    }
</ng-form>